$(function() {
    $('#loggedInToast').toast('show');
});
